import React from "react";

import styled from "styled-components/macro";

import { useCategoryCardContext } from "Dashboard/DashboardCards/DashboardCards";
import unoPiggyBank from "Payments/FundItPage/images/uno-piggy-bank.png";

import FnrIcon from "UI/FnrIcon";

const Icon = () => {
  const { icon } = useCategoryCardContext();
  if (!icon) return null;
  return (
    <>
      {icon === "piggybank" ? (
        <PiggyBankImage />
      ) : (
        <IconWrapper>
          <FnrIcon icon={icon} />
        </IconWrapper>
      )}
    </>
  );
};

const IconWrapper = styled.div`
  font-size: 32px;
  line-height: 24px;
  text-align: center;
  flex-shrink: 0;
  color: ${(props) => props.theme.colors.white};
`;
const PiggyBankImage = styled.div`
  background-image: url(${unoPiggyBank});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  opacity: 0.8;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
`;

export default Icon;
